module.exports = __webpack_public_path__ + "media/images/Adherent-active-0f399937628c2bcb6bc05001b960f3a6.png";